module.exports = __webpack_public_path__ + "img/about_bg_bottom.99bc868b.png";